module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Gautreaux\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Tim Gautreaux")]), _vm._v("'s work has appeared in "), _c('I', [_vm._v("Harpers")]), _vm._v(","), _c('I', [_vm._v(" The Atlantic Monthly")]), _vm._v(", "), _c('I', [_vm._v("GQ")]), _vm._v(", "), _c('I', [_vm._v("Story")]), _vm._v(", and "), _c('I', [_vm._v("Be")]), _vm._v("s"), _c('I', [_vm._v("t")]), _c('I', [_vm._v("American Short Stories")]), _vm._v(".  He is the author of "), _c('I', [_vm._v("Welding with Children, Same Place, Same Things, ")]), _vm._v("and "), _c('I', [_vm._v("The Next Step in the Dance.")]), _vm._v(" He lives in Hammond, Louisiana.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uE9zHr/images/9781466833937.jpg?1724536005863",
      "alt": "This image is the cover for the book Welding with Children"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Welding with Children\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A master storyteller's triumphant, moving collection about lost souls, found love, and rediscovered tradition")]), _c('br'), _c('br'), _vm._v("Tim Gautreaux returns to the form that won him his first fans, with tales of family, sin, and redemption: from a man who realizes his grandchildren are growing up without any sense of right or wrong, and he's to blame; to a camera repairman who uncovers a young woman's secret in the undeveloped film she brings him; to a one-armed hitch-hiker who changes the life of the man who gives her a ride."), _c('br'), _c('br'), _vm._v("Each one a small miracle of storytelling and compassion, these stories in "), _c('i', [_vm._v("Welding with Children")]), _vm._v(" are a joyous confirmation of Tim Gautreaux's rare and generous talent.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Picador\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0